/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q3_QuestionInputs */

const en_home_faq_q3_question = /** @type {(inputs: Home_Faq_Q3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What can I access through the customer portal?`)
};

const fr_home_faq_q3_question = /** @type {(inputs: Home_Faq_Q3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que puis-je faire via le portail client ?`)
};

/**
* | output |
* | --- |
* | "What can I access through the customer portal?" |
*
* @param {Home_Faq_Q3_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q3_question = /** @type {((inputs?: Home_Faq_Q3_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q3_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q3_question(inputs)
	return fr_home_faq_q3_question(inputs)
});